.container {
  position: absolute;
  overflow: auto;
  display: flex;
  flex-direction: column;
  z-index: 1002;
  height: 100%;
  width: calc(100% - 5.6rem);
  max-width: 32rem;
  right: 0;
  top: 0;
  background: var(--color-grayscale-shark);
  padding: 2.4rem 1.6rem;
  transition: all 200ms ease-in;
  transform: translateX(0);
  border-left: solid 1px var(--content-border-color);

  &[data-is-closed='true'] {
    transform: translateX(100%);
  }

  @media screen and (min-width: $bp-medium) {
    display: none;
  }
}
